import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Shopping: React.FC<SvgProps> = (props) => {
  return (
    <Icon width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        d="M9 16.5C9.82843 16.5 10.5 17.1716 10.5 18C10.5 18.8284 9.82843 19.5 9 19.5C8.17157 19.5 7.5 18.8284 7.5 18C7.5 17.1716 8.17157 16.5 9 16.5ZM15 16.5C15.8284 16.5 16.5 17.1716 16.5 18C16.5 18.8284 15.8284 19.5 15 19.5C14.1716 19.5 13.5 18.8284 13.5 18C13.5 17.1716 14.1716 16.5 15 16.5ZM7.33594 7.5H18.9346L17.2324 15.1631L16.5 15.75H8.25L7.51758 15.1631L6.01953 8.42188L5.41406 6H3.75V4.5H6.58594L7.33594 7.5ZM8.85156 14.25H15.8984L17.0654 9H7.68457L8.85156 14.25Z"
        fill="currentColor"
      />
    </Icon>
  )
}
